import { createLazyComponent, LazyModule } from 'owa-bundling';
import { withNetworkErrorHandler } from 'mini-error-handler/lib/components/withNetworkErrorHandler';
import { getOwaLazyErrorConfig } from 'mini-error-handler/lib/utils/getOwaLazyErrorConfig';
import { signalWorkflowEvent } from 'mini-workflow-manager';
import { DatapointStatus } from 'owa-analytics-types';
import { COMPOSE_MAIL_FAILED } from 'mini-mail-workflow-tracking/lib/constants/ComposeMailWorkflowConstants';

// Chunk name is same the the chunk which contains compose actions for mini mail (mini-mail-compose-actions-mail)
const lazyModuleComposeMail = new LazyModule(
    () => import(/* webpackChunkName: "MailCompose" */ './lazyIndex')
);

export const MailCompose = createLazyComponent(lazyModuleComposeMail, m => m.MailCompose);

export const LazyMailCompose = withNetworkErrorHandler(
    null,
    getOwaLazyErrorConfig(
        lazyModuleComposeMail,
        m => m.MailCompose,
        null,
        () => {
            const error = new Error('[Compose] Bundle load failed');
            signalWorkflowEvent(COMPOSE_MAIL_FAILED, undefined, null, {
                error,
                status: DatapointStatus.UserError,
            });
        },
        error => {
            signalWorkflowEvent(COMPOSE_MAIL_FAILED, undefined, null, {
                error,
                status: DatapointStatus.ClientError,
            });
        }
    )
);

// Chunk name is same the the chunk which contains compose actions for mini calendar (mini-mail-compose-actions-calendar)
const lazyModuleComposeCalendar = new LazyModule(
    () => import(/* webpackChunkName: "MailComposeCalendar" */ './lazyIndex')
);
export const MailComposeCalendar = createLazyComponent(
    lazyModuleComposeCalendar,
    m => m.MailCompose
);

// Chunk name is same the the chunk which contains newMessage compose action (mini-mail-compose-actions-common)
const lazyModuleComposeCommon = new LazyModule(
    () => import(/* webpackChunkName: "MailComposeCommon" */ './lazyIndex')
);

export const MailComposeCommon = createLazyComponent(lazyModuleComposeCommon, m => m.MailCompose);
